import { z, type ZodSchema, type ZodTypeAny } from "zod";
import { zPassword, zPhoneNumber, ageCheck } from "./validators";

const IS_SIXTEEN = ageCheck(16);

// Function to create a Zod schema from default values
// Function to create a Zod schema from default values
export const createZodSchema = <T extends Record<string, string | number>>(defaultValues: T): ZodSchema<T> => {
  const schema = Object.entries(defaultValues).reduce((schema, [key, val]) => {
    let valSchema: ZodTypeAny;

    switch (true) {
      case typeof val === 'string' && key === 'email':
        valSchema = z.string().email();
        break;
      case typeof val === 'string' && key === 'password':
        valSchema = zPassword;
        break;
      case typeof val === 'string' && (key === 'title' || key === 'instructor' || key === 'type'):
        valSchema = z.string().trim().min(1);
        break;
      case typeof val === 'string' && key === 'date_of_birth':
        valSchema = IS_SIXTEEN;
        break;
      case typeof val === 'string' && (key === 'start' || key === 'end'):
        valSchema = z.string().min(4);
        break;
      case typeof val === 'string' && key === 'phone_number':
        valSchema = zPhoneNumber;
        break;
      // Custom check for decimals
      case typeof val === 'string' && (key === 'pt_rate' || key === 'group_rate'):
        valSchema = z.string().max(5);
        break;
      case typeof val === 'string':
        valSchema = z.string();
        break;
      case typeof val === 'number':
        valSchema = z.number();
        break;
      default:
        valSchema = z.unknown();
        break;
    }
    return schema.extend({
      [key]: valSchema,
    });
  }, z.object({}));

  return schema as unknown as ZodSchema<T>;
};